import { http } from '../http';
import { API_CONFIG } from '@/config/api';

export interface FieldConfig {
  id: number;
  function_method: string;
  function_name: string | null;
  create_time: string;
  create_user_id: number;
  update_user_id: number;
  update_time: string;
  default_field_list: unknown[] | null;
  field_list: FieldItem[];
}

export interface FieldItem {
  field_name: string;
  display_name: string;
  field_type: string;
  is_visible: boolean;
}

export interface SearchToolResponse {
  field_conf: FieldConfig;
  total_pages: number;
  page_index: number;
  total_count: number;
  data_list: Record<string, unknown>[];
  sum_data: unknown[] | null;
  columns: unknown[] | null;
  group_name: string | null;
  tips: string | null;
  specific_field_result: unknown | null;
  exception_message: string | null;
}

export const searchToolApi = {
  executeSearch: async (params:any): Promise<SearchToolResponse> => {
    // 将params等于null的字段改为''
    Object.keys(params).forEach(key => {
      if (params[key] === null) {
        params[key] = '';
      }
    });
    console.log('params',params);
    return http.get<SearchToolResponse>(API_CONFIG.endpoints.searchTool, {params});
  }
}; 